export default __webpack_public_path__ + "static/media/VipProgram.058e8a11.png";